module.exports = __webpack_public_path__ + "static/media/fairy.2ede55df.png";